import { DynamicAlignmentHub } from './DynamicAlignmentHub';
import { ProfileKeyCode } from '../DynamicProfileEnums';
import { DynamicProfileStoreBase } from '../DynamicProfileStoreBase';
import Graphic from '@arcgis/core/Graphic';
import Point from '@arcgis/core/geometry/Point';
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import {reachHighlightSymbol} from 'cd-eft/models/Stores/DynamicProfile/profileSymbolsAndLabels';
import { AppConstants } from 'cd-eft/appConstants';

class DynamicAlignmentProfileStore extends DynamicProfileStoreBase {
  public hub: DynamicAlignmentHub;
  private _profileTrackLayer: GraphicsLayer | undefined = void 0;
  private viewPointerMoveHandle;
  private viewPointerLeaveHandle;
  /**
   *
   */
  constructor(hub: DynamicAlignmentHub) {
    super();

    this.hub = hub;
    this.profileKeys = this.hub._isTerraceAlignment ? [ProfileKeyCode.TGS, ProfileKeyCode.REACH] : [ProfileKeyCode.IA];
  }

  // SetStore
  set setStore(setStore) {
    if (this.hub) this.hub.setStore = setStore;
  }

  get setStore() {
    return this.hub.setStore;
  }

  protected handlePolylineCreateEvent(event): void {}
  protected handlePointCreateEvent(event): void {}
  protected handleReshapeEvent(event): void {}
  protected initSketchVm(): void {}
  async updateUgoTableOnChangeStationValue(): Promise<void> { }
  async createChannelFromSavedUgo(): Promise<void> { }
  async redrawUgoProfiles(): Promise<void> { }

  public removeSketch(): void {
    this.removeReachStationLayer();
    this.sketchLayer?.graphics.removeAll();
    this.removeMidPointStationLayer();
  }

  private get profileTrackLayer(): GraphicsLayer | undefined {
    const id = 'editing_track_lyr';
    const title = 'editing track';

    if (!this._profileTrackLayer) {
      const lyr = this._profileView?.map.findLayerById(id);
      if (lyr) {
        this._profileTrackLayer = lyr as GraphicsLayer;
      } else {
        this._profileTrackLayer = new GraphicsLayer({ id, title, listMode: 'hide' });
        this._profileView?.map.add(this._profileTrackLayer);
      }
    }

    return this._profileTrackLayer;
  }

  public trackProfilePoint(point: Point, id: string) {
    if (!this.profileTrackLayer?.graphics.toArray().some(graphic => {
      return (graphic.attributes && graphic.attributes.id && (graphic.attributes.id === id));
    })) {
      const graphic = new Graphic({
        geometry: point,
        symbol: reachHighlightSymbol,
        attributes: { id: id }
      });
      this.profileTrackLayer?.graphics.push(graphic);
    }
  }

  public unTrackProfilePoint(id: string) {
    const graphicToRemove = this.profileTrackLayer?.graphics.find(graphic => {
      return (graphic.attributes && graphic.attributes.id && (graphic.attributes.id === id));
    });
    if (graphicToRemove) {
      this.profileTrackLayer?.graphics.remove(graphicToRemove);
    }
  }

  public trackStation(station: any, xStretchFactor, yStretchFactor) {
    const stationX = xStretchFactor ? station.stationDistance * xStretchFactor : station.stationDistance;
    const point = new Point({
      x: stationX,
      y: station.z * (yStretchFactor || AppConstants.profileStretchFactor),
      spatialReference: this._profileView?.spatialReference
    });
    this.trackProfilePoint(point, `id_${station.stationName}`);
  }

  public untrackStations() {
    this.profileTrackLayer?.removeAll();
  }

  protected async setUpTerraceAlignmentView(stations, xStretchFactor, yStretchFactor) {
    await this.hub?.MapStore?.setAlignment(stations);

    this.viewPointerMoveHandle = this._profileView!.on('pointer-move', (async (e: __esri.ViewPointerMoveEvent) => {
      const point = this._profileView?.toMap({ x: e.x, y: e.y });
      if (point && (point.x / xStretchFactor >= 0) && (point.x / xStretchFactor <= this.alignmentCenterLine[this.alignmentCenterLine.length-1][0])) {
        this.hub?.MapStore?.setTracker(point.x / (xStretchFactor || 1), point.y / yStretchFactor);
      } else {
        this.hub?.MapStore?.clearTracker();
      }
    }));

    this.viewPointerLeaveHandle = this._profileView!.on('pointer-leave', (e: __esri.ViewPointerMoveEvent) => {
      this.hub?.MapStore?.clearTracker();
    });
  }
}

export { DynamicAlignmentProfileStore };
